import api from "@/lib/api"

export async function novaResposta(formData) {
  const { data } = await api.post("/secretaria-digital/solicitacao/responder", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return data
}

